import React from "react";
import { Link } from "react-router-dom";

const AdminDashboard = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Admin Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Link
          to="/admin/users"
          className="p-4 bg-blue-500 text-white rounded hover:bg-blue-600 text-center"
        >
          User Management
        </Link>
        <Link
          to="/admin/stories"
          className="p-4 bg-blue-500 text-white rounded hover:bg-blue-600 text-center"
        >
          Story Management
        </Link>
        <Link
          to="/admin/categories"
          className="p-4 bg-blue-500 text-white rounded hover:bg-blue-600 text-center"
        >
          Category Management
        </Link>
      </div>
    </div>
  );
};

export default AdminDashboard; 